<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="350" persistent>
      <v-card>
        <v-card-title
          class="headline body-1 blue-grey darken-1 lighten-1 white--text font-weight-thin"
          primary-title
        >
          <v-icon class="white--text mr-2">mdi-wallet</v-icon>Carteira
        </v-card-title>
        <v-card-text class="pa-8">
          <v-fade-transition mode="out-in">
            <set-credit-wallet></set-credit-wallet>
          </v-fade-transition>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue-grey"
            text
            @click="backBtn"
            v-show="getConfirmCreditWallet"
          >
            Voltar
          </v-btn>
          <v-btn color="blue-grey" text @click="closeWT">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import eventBus from "../../main";
import SetCreditWallet from "../dashboard/client/wallet/SetCreditWallet";
import { mapHelper } from "@/store/helper";

export default {
  name: "OpenChargeWallet",
  components: {
    SetCreditWallet
  },
  data: () => ({
    dialog: false,
    showBackSaldo: false,
    valid: true,
    value: true,
    loading: false
  }),
  methods: {
    mainDispatch() {
      const payload = {
        target: false,
        close: true,
        amount: ""
      };
      return this.$store.dispatch("setConfirmCreditWallet", payload);
    },
    closeWT() {
      this.dialog = false;
      //Reset Form
      this.mainDispatch();
    },
    backBtn() {
      //Back to charge wallet
      this.mainDispatch();
    }
  },
  computed: {
    ...mapHelper
  },
  created() {
    const self = this;
    eventBus.$on("openChargeWallet", function(value) {
      self.dialog = value;
    });
    eventBus.$on("openBackSaldo", function(value) {
      self.showBackSaldo = value;
    });
  }
};
</script>
<style scoped>
.m-center {
  text-align: center;
}
</style>
